import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useSystemStore = defineStore('system', () => {
  const showHeader = ref(false)
  const showFooter = ref(false)

  return {
    showHeader,
    showFooter,
  }
})
